<div 
  class="d-flex flex-column bg-light card-container h-100"
>
  <img
    *ngIf="!!highlighted && showBestSeller"
    src="/assets/images/pricingTable/bestSeller.svg"
    class="img-fluid best-seller"
    alt="bestSeller"
  />

  <div
    class="card h-100 w-100 d-inline-block d-flex flex-column bg-light"
    [class.highlighted]="!!highlighted"
    [class.clickable]="!viewOnly"
    [ngClass]="hasOrangeBorder ? 'card-border-color' : ''"
  >
    <div
      [ngClass]="showPeachBanner ? planTitle === 'identialert' ? 'card-peach-header card-brand-header' : 'card-peach-header' : 'card-header'"
      [class.small-header]="
        !(!!planShortSubtitle && showShortDescription) && !(!!planLongSubtitle && showFeatures)
      "
    >
      <img *ngIf="!hideIcon" [src]="imageUri" class="img-fluid card-image" alt="planImage" />

      <div *ngIf="showPeachBanner">
        <h2>
          {{ planTitle }}
        </h2>
      </div>

      <div *ngIf="!showPeachBanner" class="mb-0 mt-3 card-title">{{ planTitle }}</div>
      <h6 *ngIf="!!planShortSubtitle && showShortDescription && !showPeachBanner" class="mt-2">
        {{ planShortSubtitle }}
        <b *ngIf="hidePlusFromSubtitle !== true" class="plan-subtitle"></b>
      </h6>
      <h6 *ngIf="!!planLongSubtitle && showFeatures && !showPeachBanner" class="mt-2">
        {{ planLongSubtitle }}
        <b *ngIf="hidePlusFromSubtitle !== true" class="plan-subtitle">PLUS:</b>
      </h6>
    </div>

    <div class="my-0 py-2 pr-2 me-1" *ngIf="shortDescriptionList && shortDescriptionList.length">
      <ul class="text-start">
        <li *ngFor="let description of shortDescriptionList">
          <div [innerHTML]="description"></div>
        </li>
      </ul>
    </div>

    <div class="card-body pricing-table-body">
      <h5 *ngIf="!!planShortSubtitle && showShortDescription && showPeachBanner" class="mt-4">
        {{ planShortSubtitle }}
        <b *ngIf="hidePlusFromSubtitle !== true" class="plan-subtitle"></b>
      </h5>
      <h5 *ngIf="!!planLongSubtitle && showFeatures && showPeachBanner && !planShortSubtitle" class="mt-4">
        {{ planLongSubtitle }}
        <b *ngIf="hidePlusFromSubtitle !== true" class="plan-subtitle">PLUS:</b>
      </h5>
      <div
        *ngIf="!hidePrices && !pricingInfoLines"
        class="price-box d-flex flex-column justify-content-center"
      >
        <div *ngIf="!alternativePlanOptionsAvailable && yearlyPrice" class="btn-lg p-0 pricing-font">
          {{ yearlyPrice }}
          <span class="pricing-font-description">/ year</span>
        </div>
        <div *ngIf="!!alternativePlanOptionsAvailable && yearlyPrice">
          <button
            class="btn btn-link btn-lg text-dark p-0 pricing-font"
            (click)="useMonthlyPlan = false"
          >
            <fa-icon
              [icon]="['far', useMonthlyPlan === false ? 'check-square' : 'square']"
              class="me-2"
            ></fa-icon>
            {{ yearlyPrice }}
            <span class="pricing-font-description">/ year</span>
          </button>
        </div>
        <div *ngIf="!!alternativePlanOptionsAvailable">
          <button
            class="btn btn-link btn-lg text-dark p-0 pricing-font"
            (click)="useMonthlyPlan = true"
          >
            <fa-icon
              [icon]="['far', useMonthlyPlan === true ? 'check-square' : 'square']"
              class="me-2"
            ></fa-icon>
            {{ monthlyPrice }}
            <span class="pricing-font-description">/ month</span>
            <p class="pricing-font-description" *ngIf="!!priceNote">
              {{ priceNote }}
            </p>
          </button>
        </div>
        <div *ngIf="!!oneOffPrice" class="btn-sm p-0 pricing-font">
          <span class="pricing-font-description">{{ oneOffPrice }}</span>
        </div>
      </div>
      <div
        *ngIf="!hidePrices && !!pricingInfoLines"
        class="price-box d-flex flex-column justify-content-center"
      >
        <div *ngFor="let pricingInfoLine of pricingInfoLines" class="p-0 pricing-font">
          <div class="d-inline-flex">
            {{ pricingInfoLine.priceAmount }}
          </div>
          <div class="pricing-info-description my-0 py-0 ms-1 d-inline-flex">
            {{ pricingInfoLine.priceDescription }}
          </div>
        </div>
      </div>
      <div class="text-center my-0" *ngIf="showShortDescription">
        <p class="description" [innerHTML]="description">
        </p>
      </div>

      <div *ngIf="showSmartTagInfo && smartTagLimit && smartTagLimit.freeTags > 0" class="text-center m-1">
        <span>
          Customise smart tags for up to <strong>{{ smartTagLimit.freeTags }}</strong> pet{{ smartTagLimit.freeTags !== 1 ? 's' : '' }}
        </span>
      </div>

      <div class="mb-0 mt-3 d-flex flex-column justify-content-center" *ngIf="showInfoLine">
        <span class="info-line clickable-tag ms-0 ps-0" (click)="navigateToProductPage()">
          Learn more
          <fa-icon
            [icon]="['fas', 'circle-info']"
            class="clickable-tag ms-1"
            (click)="navigateToProductPage()"
          >
          </fa-icon>
        </span>
      </div>

      <div class="my-0 py-2 feature-list" *ngIf="showFeatures && !descriptionList">
        <ul class="list-unstyled text-start my-0">
          <li *ngFor="let feature of normalizedFeatures">
            <fa-icon
              [icon]="['fas', 'check']"
              class="me-1"
              [class.highlighted-icon]="highlighted"
            ></fa-icon>
            <span>{{ feature.content }}</span>
          </li>
        </ul>
      </div>

      <div class="my-0 py-2 pr-2" *ngIf="descriptionList">
        <ul class="text-start">
          <li *ngFor="let description of descriptionList">
            <div [innerHTML]="description"></div>
            <!-- {{ description }} -->
          </li>
        </ul>
      </div>

      <div
        class="text-center my-0 price-wrapper"
        *ngIf="priceTextsVisible && (showShortDescription || showFeatures)"
      >
        <h5 class="mt-3">
          <span [class.bold-price-title]="showFeatures">{{ yearlyPrice }}</span>
          per year
        </h5>
        <h6 *ngIf="!!monthlyPrice">{{ monthlyPrice }} per month</h6>
        <h6 *ngIf="!!oneOffPrice">{{ oneOffPrice }}</h6>
        <h6 *ngIf="!!priceNote">{{ priceNote }}</h6>
      </div>
    </div>
    <div class="card-warning" *ngIf="warning">
      <div class="card-warning-content">
        {{ warning }}
      </div>
    </div>

    <div
      class="card-footer d-flex flex-column justify-content-end"
      [class.align-items-center]="hasBuyNow"
    >
      <button
        *ngIf="hasBuyNow"
        class="btn-buy-now"
        type="button"
        (click)="buyIdentialertSubs()"
        [disabled]="disabledBuyNow"
      >
        Buy Now
      </button>

      <button
        *ngIf="showButton"
        class="btn"
        [class.btn-outlined]="!highlighted"
        [class.btn-brand-orange]="!!highlighted"
        [class.btn-learn-more]="hasBuyNow"
        (click)="select()"
        [disabled]="disabled"
        type="button"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
